import React, { Component } from 'react';
import $ from 'jquery';

class ValidateItems extends Component{

    componentDidMount(){
       
    }

    closeConfirm = async () => {
        const {continuePage} = this.props;
        $('#validateItems').modal('hide');  
        continuePage();
    }

   
    Continue =()=>{
        const {addToTable} = this.props;
        $('#validateItems').modal('hide');  
        addToTable();
    }
    render() {
        const {Balance,Codigo,CardName} = this.props;
        return (
                <div className="modal" tabIndex="-1" role="dialog" id="validateItems" style ={{top:'30%'}} >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                        <div className="modal-body">
                            <p>La selección actual se perdera</p>
                            <p>¿Desea agregar los artículos?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.Continue}> Si </button>
                            <button type="button" className="btn botonCorrect text-black" onClick={this.closeConfirm}>No</button>
                        </div>
                        </div>
                    </div>
                </div>
        );  
    }
}
export default ValidateItems;